import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {
  devicesList,
  hoursTypesList,
  intervalsList,
} from 'src/app/modules/filters/constants';
import { filter } from 'rxjs/operators';
import { Building, BuildingsData, Floor } from '@modules/buildings/models';
import { BuildingsService } from '@modules/buildings/services/buildings.service';
import { BuildingsDataDto } from '@modules/buildings/dtos';

const initialBuildingsData = {
  buildings: [],
  floors: [],
  hoursTypes: [],
  intervals: [],
  devices: [],
};

@Injectable({
  providedIn: 'root',
})
export class BuildingsFacade {
  private readonly buildingsDataSubject = new BehaviorSubject<BuildingsData>(
    initialBuildingsData,
  );
  public readonly buildingsData$ = this.buildingsDataSubject
    .asObservable()
    .pipe(
      filter(
        (buildingsData: BuildingsData) =>
          buildingsData !== initialBuildingsData,
      ),
    );

  private get buildingsData(): BuildingsData {
    return this.buildingsDataSubject.value;
  }

  private readonly buildingsService = inject(BuildingsService);

  loadBuildingsData(): void {
    this.buildingsService
      .fetchBuildingsData()
      .subscribe((buildingsData: BuildingsDataDto) => {
        this.buildingsDataSubject.next({
          ...buildingsData,
          hoursTypes: hoursTypesList,
          intervals: intervalsList,
          devices: devicesList,
        } as BuildingsData);
      });
  }

  filterFloors(buildingId: number): Floor[] {
    const allFloors = [...this.buildingsData.floors];

    return allFloors.filter((floor) => floor.buildingId === buildingId);
  }

  getModelById({
    buildingId,
    floorId,
  }: {
    buildingId?: number;
    floorId?: number;
  }): Building | Floor | undefined {
    if (buildingId) {
      return this.buildingsData.buildings.find(
        (building) => building.buildingId === buildingId,
      );
    } else if (floorId) {
      return this.buildingsData.floors.find(
        (floor) => floor.floorId === floorId,
      );
    }

    return undefined;
  }
}
